import { withInstall } from '@meng-ui-vue/utils'
import Button from './src/button.vue'

export const MxButton = withInstall(Button)
export default MxButton

//export * from './src/button'
